import { queueFormDocumentReviewMethods } from './queue_form_document_review_methods';
import { queueFormFileMethods } from './queue_form_file_methods';
import { queueFormHistoryMethods } from './queue_form_history_methods';
import { queueFormHistoryResultMethods } from './queue_form_history_result_methods';
import { queueFormLoadMethods } from './queue_form_load_methods';
import { queueFormNavigationMethods } from './queue_form_navigation_methods';
import { queueFormRepeatableMethods } from './queue_form_repeatable_methods';
import { queueFormSubmitMethods } from './queue_form_submit_methods';

export const queueFormMethods = {
  ...queueFormLoadMethods,
  ...queueFormHistoryMethods,
  ...queueFormHistoryResultMethods,
  ...queueFormRepeatableMethods,
  ...queueFormNavigationMethods,
  ...queueFormFileMethods,
  ...queueFormDocumentReviewMethods,
  ...queueFormSubmitMethods
};
